import { defineMessages } from 'react-intl';

export default defineMessages({

applicationContent: {
    id: 'twia.quoteandbind.residential.confirmation.Application',
    defaultMessage: `
    •  Offer Letter and Payment Coupon
    •  Application`,
},
issuedApplicationContent: {
    id: 'twia.quoteandbind.residential.confirmation.issuedapplicationContent',
    defaultMessage: `
    •  Declaration Page
    •  Policy Package
    •  Application`,
},
});